import { CoreInitiativesTasksByIdName } from './name';
import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchInitiativeTask } from '@api';
import { updateInitiativeReferences } from '../../_idMap/actions';

export const coreInitiativesTasksByIdPatchAsyncSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			({ initiativeId, taskId, ...rest }) =>
				updateInitiativeReferences([
					{
						initiativeId: initiativeId,
						tasks: {
							toUpdateById: {
								id: taskId,
								update: rest
							}
						}
					}
				])
		]
	},
	name: CoreInitiativesTasksByIdName,
	receive: false,
	request: true,
	requestHandler: patchInitiativeTask
});
